import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { gql, useQuery } from '@apollo/client'
import { getGroupUrl } from 'helpers'

import EntityAddEditForm from 'js/components/EntityActions/EntityAddEditForm'
import NotFound from 'js/core/NotFound'
import { genericArticleEditFragment } from 'js/genericArticle/fragments/genericArticleEntity'

const Edit = ({ subtype }: { subtype: string }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const params = useParams()
    const { guid } = params

    const { loading, data } = useQuery(GET_GENERIC_ARTICLE_EDIT, {
        variables: {
            guid,
        },
    })

    if (loading) return null
    if (!data || !data.entity) return <NotFound />

    const { entity } = data
    const { contentType } = entity
    const { name } = contentType

    const afterDelete = () => {
        navigate(`${getGroupUrl(params)}/cct?`, {
            replace: true,
        })
    }

    return (
        <EntityAddEditForm
            title={t('custom-content-type.edit-item', {
                name: name.toLowerCase(),
            })}
            deleteTitle={t('form.delete')}
            subtype={subtype}
            entity={entity}
            afterDelete={afterDelete}
            refetchQueries={['ActivityList', 'GetGenericArticle']}
            {...({} as any)}
        />
    )
}

const GET_GENERIC_ARTICLE_EDIT = gql`
    query GetGenericArticle($guid: String!) {
        entity(guid: $guid) {
            ${genericArticleEditFragment}
        }
    }
`

export default Edit
